import { Button, Modal, Table, Typography } from '@scale/scaleui';
import { useCallback } from 'react';
import { useFetchUserInfo } from 'react-scale/components/ExpertManagement/hooks/queries/useFetchUserInfo';
import { UserInfo } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetDiscourseCategoryResult } from '@scale/shared/types/expertManagement';

interface AssociatedChannelsModalProps {
  open: boolean;
  onClose: () => void;
  userInfo: UserInfo;
}

interface AssociatedChannelsManagerProps {
  title: string;
  channels: GetDiscourseCategoryResult[];
}

function AssociatedChannelsManager({ title, channels }: AssociatedChannelsManagerProps) {
  const CHANNEL_COLUMNS = [
    {
      id: 'category',
      header: 'Category',
      cell: function CategoryCell(props: any) {
        const { name, discourseId } = props.row.original;
        return (
          <a
            href={`https://community.outlier.ai/c/${name}/${discourseId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="flex flex-row items-center">
              {name}/{discourseId}
              <FontAwesomeIcon icon="external-link-alt" className="text-xs ml-2" />
            </div>
          </a>
        );
      },
    },
  ];

  return (
    <div className="flex flex-col gap-2">
      {title && <Typography.Subtitle3>{title}:</Typography.Subtitle3>}
      {channels && <Table columns={CHANNEL_COLUMNS} data={channels} />}
    </div>
  );
}

export function AssociatedChannelsModal({ open, onClose, userInfo }: AssociatedChannelsModalProps) {
  const { id } = userInfo;
  const { refetch, isFetching } = useFetchUserInfo(id);
  const { associatedDiscourseCategories } = userInfo;

  const closeModal = useCallback(async () => {
    await refetch();
    onClose();
  }, [onClose, refetch]);

  return (
    <Modal title="Associated Categories" open={open} onClose={onClose}>
      <div className="flex flex-col justify-between" style={{ minHeight: '5vh', minWidth: '50vw' }}>
        <div className="flex flex-col gap-4">
          <AssociatedChannelsManager channels={associatedDiscourseCategories} title="" />
        </div>
        <div className="flex justify-end gap-1 mt-4">
          <Button disabled={isFetching} onClick={closeModal} variant="danger">
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
}
